import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=471bca2e&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"
import style1 from "./ContactList.vue?vue&type=style&index=1&id=471bca2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bca2e",
  null
  
)

export default component.exports